module.exports = "/_next/static/media/60f054cd632a54f312073387bcb54ea2.svg";